const ROOT = "HtmlComponent";
const IFRAME_COMPONENT = "iframeComponent";
const TOOLBAR_BUTTON_EDIT_HTML = "baseToolbarButton_edit";
const EDIT_PANEL = "htmlEditPanel";
const EDIT_PANEL_SEGMENTED_TOGGLE = "htmlEditPanel_htmlSegmentedToggle";
const EDIT_PANEL_HTML_INPUT = "htmlEditPanel_htmlInput";
const EDIT_PANEL_URL_INPUT = "htmlEditPanel_urlInput";
export {
  EDIT_PANEL,
  EDIT_PANEL_HTML_INPUT,
  EDIT_PANEL_SEGMENTED_TOGGLE,
  EDIT_PANEL_URL_INPUT,
  IFRAME_COMPONENT,
  ROOT,
  TOOLBAR_BUTTON_EDIT_HTML
};
//# sourceMappingURL=dataHooks.js.map
